/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentDetailTranscriptionQueryResponse, GetFragmentDetailTranscriptionPathParams, GetFragmentDetailTranscription404 } from "../models/GetFragmentDetailTranscription";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFragmentDetailTranscription } from "../axios/getFragmentDetailTranscription";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFragmentDetailTranscriptionQueryKey = (id: GetFragmentDetailTranscriptionPathParams["id"]) => ["web-app-bff-api", { url: '/fragments/:id/transcription', params: {id:id} }] as const

export type GetFragmentDetailTranscriptionQueryKey = ReturnType<typeof getFragmentDetailTranscriptionQueryKey>

export function getFragmentDetailTranscriptionQueryOptions(id: GetFragmentDetailTranscriptionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFragmentDetailTranscriptionQueryKey(id)
        return queryOptions<GetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<GetFragmentDetailTranscription404>, GetFragmentDetailTranscriptionQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFragmentDetailTranscription(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get fragment transcription
 * {@link /fragments/:id/transcription}
 */
export function useGetFragmentDetailTranscription<TData = GetFragmentDetailTranscriptionQueryResponse, TQueryData = GetFragmentDetailTranscriptionQueryResponse, TQueryKey extends QueryKey = GetFragmentDetailTranscriptionQueryKey>(id: GetFragmentDetailTranscriptionPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<GetFragmentDetailTranscription404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getFragmentDetailTranscriptionQueryKey(id)
         

         const query = useQuery({
          ...getFragmentDetailTranscriptionQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetFragmentDetailTranscription404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}